import { apiClient } from "@spiriidk/auth";
import { createTypedFetch, zodValidator } from "@spiriidk/utils";

const TECH_API_URL = import.meta.env.VITE_TECH_API_URL as string;

const typedFetch = createTypedFetch({
  baseUrl: TECH_API_URL,
  fetch: apiClient,
});

const typedFetchNoImpersonate = createTypedFetch({
  baseUrl: TECH_API_URL,
  fetch: (url, init) => apiClient(url, init, { skipImpersonate: true }),
});

export { typedFetch, typedFetchNoImpersonate, zodValidator };
